export function useKey() {
  const route = useRoute();
  const config = useRuntimeConfig();
  const locale = useCookie('vsf-locale');
  const currency = useCookie('vsf-currency');
  const country = useCookie('vsf-country');
  const variant = computed(() => route.query.variant || '');
  
  return computed(() => `${route.fullPath}__${locale.value}__${currency.value}__${country.value}__${variant.value}`);
}
